import CardSupercard from './CardSupercard'
export default CardSupercard